import api from "src/spintr/SpintrApi"

export const postMediaPlayCountUpdate = (uberId: number, url: string) => {
    api.post(`/api/v1/blogposts/play/${uberId}`, { url })
}

export default postMediaPlayCountUpdate;